module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_pucillo_sm-3632ac5ce593f8c6d39de6ed31c94641.png";